
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'LocationSinglePage',
  head() {
    let locationName = this.location && this.location.name ? this.location.name : this.location ? this.location.city : ''
    if (locationName === 'Livonia Lees') {
      locationName = `Livonia, ${this.location.state}`
    }
    const page = {
      name: `Lee's Famous Recipe Chicken | Best Chicken in ${locationName}`,
      description: this.location && this.location.long_description ? this.location.long_description : `Our Famous Recipe chicken is always cooked fresh, never frozen. Our chicken is honey dipped & hand breaded in our special blend of herbs and spices before being pressure cooked to seal in the flavor that put Lee's on the map in the first place. We might hold on to our traditions a bit longer than others.`,
    }

    return this.$utils.head(page)
  },
  async asyncData({ $utils, params }) {
    return {
      location: await $utils.location(params.state, params.city, params.address),
      story: await $utils.content('locations/address'),
    }
  },
  async beforeMount() {
    await this.getCurrentLocation()
    this.setLoading(true)
    if (!this.location) {
      this.setLocation(null)
      this.setMenu(null)
      this.$router.push('/')
    }
    this.setLoading(false)
  },
  methods: {
    ...mapActions([ 'sendRequest' ]),
    ...mapMutations([ 'setLoading', 'setLocation', 'setMenu' ]),
    async getCurrentLocation() {
      if (this.location) {
        this.setLoading(true)
        const locConfig = {
          method: 'get',
          url: `locations/${this.location.menu_id}`,
          params: {
            byMenuId: true
          }
        }
        const response = await this.sendRequest(locConfig)
        if (response.status === 'ok') {
          this.location = response.data
        }
        this.setLoading(false)
      }
    }
  },
}
